var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.13 129.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:gray;stroke-miterlimit:10;stroke-width:6.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_481",
    "data-name": "Trazado 481",
    className: "cls-1",
    d: "M73.55,55.15v26.6A86.46,86.46,0,0,1,3,82.84V55.18A19.53,19.53,0,0,1,22.51,35.6H54A19.55,19.55,0,0,1,73.56,55.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_482",
    "data-name": "Trazado 482",
    className: "cls-1",
    d: "M73.55,55.15v26.6A86.46,86.46,0,0,1,3,82.84V55.18A19.53,19.53,0,0,1,22.51,35.6H54A19.55,19.55,0,0,1,73.56,55.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_485",
    "data-name": "Trazado 485",
    className: "cls-1",
    d: "M38.28,3A19.66,19.66,0,1,1,18.62,22.68,19.66,19.66,0,0,1,38.28,3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_487",
    "data-name": "Trazado 487",
    className: "cls-1",
    d: "M144.1,55.19v26.6a86.44,86.44,0,0,1-70.55,1.08V55.22A19.55,19.55,0,0,1,93.09,35.66h31.44a19.57,19.57,0,0,1,19.58,19.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_488",
    "data-name": "Trazado 488",
    className: "cls-1",
    d: "M144.1,55.19v26.6a86.44,86.44,0,0,1-70.55,1.08V55.22A19.55,19.55,0,0,1,93.09,35.66h31.44a19.57,19.57,0,0,1,19.58,19.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_491",
    "data-name": "Trazado 491",
    className: "cls-1",
    d: "M108.82,3A19.66,19.66,0,1,1,89.16,22.66,19.66,19.66,0,0,1,108.82,3h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_495",
    "data-name": "Trazado 495",
    className: "cls-1",
    d: "M111.34,92v26.6a86.44,86.44,0,0,1-70.55,1.08V92A19.54,19.54,0,0,1,60.32,72.44H91.77A19.56,19.56,0,0,1,111.34,92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_497",
    "data-name": "Trazado 497",
    className: "cls-1",
    d: "M76.05,39.79A19.66,19.66,0,1,1,56.4,59.45,19.66,19.66,0,0,1,76.05,39.79h0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso8);
export default __webpack_public_path__ + "static/media/Recurso 8.782b41538e5ddb631375b881f122bf57.svg";
export { ForwardRef as ReactComponent };